import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '../../../core/services/api/api.service';
import { Category } from '../../../models/category';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  constructor(private apiService: ApiService) {}

  saveCategory(label: string, studyId: number): Observable<Category> {
    return this.apiService.post<Category>(`/dashboard/study/${studyId}/category`, { label });
  }

  deleteCategory(categoryId: number, studyId: number): Observable<boolean> {
    return this.apiService.delete<boolean>(`/dashboard/study/${studyId}/category/${categoryId}`);
  }
}
